import { WebPushViewState, WebPushWorkflowView } from './schema/WebPushViewState';
import { LocalWebPushUserSetting } from '../schema/LocalWebPushUserSetting';
import { createStore } from 'satcheljs';

export { WebPushWorkflowView, WebPushViewState };

export const webPushStore = createStore<WebPushViewState>('webPushStore', {
    currentView: WebPushWorkflowView.None,
    webPushPermission: window.Notification && window.Notification.permission,
})();

export const localWebPushUserSettingStore = createStore<LocalWebPushUserSetting>(
    'localWebPushUserSettingStore',
    {
        userPreferenceIdentifier: null,
        lastSessionDate: null,
        uniqueDaysSessionCount: 0,
        enabled: null,
        promptCount: 0,
        lastPromptDate: null,
    }
)();

export function getLocalWebPushUserSettingStore(): LocalWebPushUserSetting {
    return localWebPushUserSettingStore;
}
